import React from 'react';
import ReactDOM from 'react-dom/client';
import '@genesisframeworks/viewer-plugin/style.css';
import App from './App';
import { validateEnvironment } from '@config/environment';
import { initWebVitals } from '@/observability';

validateEnvironment();
// PR 3 — observability. Initializes Web Vitals + custom timing reporters.
// Telemetry endpoint failures are silent; never breaks user experience.
initWebVitals();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
